// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__dYf3V","imageUploader":"EGiftCard_imageUploader__3ZNBr"};